import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  toggle (event) {
    const item = event.currentTarget.closest('.faq__item')
    if (!item) return

    // Close other items
    this.itemTargets.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.classList.remove('is-open')
      }
    })

    // Toggle current item
    item.classList.toggle('is-open')
  }
}
